import { exportToXlsx, type XlsxWorkerArgs } from '~/utils/exportXlsx'
;(self as unknown as DedicatedWorkerGlobalScope).onmessage = (
  e: MessageEvent<XlsxWorkerArgs>,
) => {
  ;(self as unknown as DedicatedWorkerGlobalScope).postMessage(
    exportToXlsx(e.data),
  )
}
